class VideoModal {
    static init() {
        this.uid = 'video-embed';
        this.modalUid = 'modal-container';
        $(`<div id="${this.modalUid}"/>`).appendTo('body');
        $('.watch-video').on('click', (element) => {
            element.preventDefault();
            this.item = $(element.currentTarget);
            this.videoID = this.item.data('id');
            this.type = this.item.data('type');
            this.launchModal();
        });
    }

    static launchModal() {
        $(`#${this.modalUid}`).html(this.modalHTML());
        $('body').addClass('modal-active');

        if (this.type == 'youtube') {
            this.setupYoutube();
        }

        if (this.type == 'vimeo') {
            this.setupVimeo();
        }

        if (this.type == 'wistia') {
            this.setupWistia();
        }

        this.setupCloseEvent();
    }

    static setupYoutube() {
        return new YT.Player(this.uid, {
            width: '100%',
            height: '100%',
            videoId: this.videoID,
            playerVars: {
                autoplay: 1
            }
        });
    }

    static setupVimeo() {
        var vimeo = new Vimeo.Player(this.uid, {
            id: this.videoID,
            width: '100%',
            muted: false,
            playsinline: true,
            autoplay: true
        });
    }

    static setupWistia() {
        window._wq = window._wq || [];
        _wq.push({
            id: this.videoID,
            options: {
                autoPlay: true,
                controlsVisibleOnLoad: true,
                endVideoBehavior: 'default',
                playerColor: '#f25a54',
            }
        });
    }

    static setupCloseEvent() {
        jQuery('.modal .close').click(() => {
            $('body').removeClass('modal-active');
            $(`#${this.modalUid}`).html('');
            return false;
        });
    }

    static modalHTML() {

        this.videoContainer = this.type == 'wistia' ?
            `<div class="video-player wistia_embed wistia_async_${this.videoID}"></div>` :
            `<div class="video-player" id="${this.uid}"></div>`;

        return `
			<div class="modal show flex items-center justify-center">
                <a href="#" class="close icon-close hover:text-red-300 absolute top-20 right-20 text-2xl text-white"></a>
                <div class="container w-full">
                    <div class="pt-56p relative">
                        ${this.videoContainer}
                    </div>
                </div>
			</div>
		`
    }
}

export default VideoModal